import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Songs } from "../../models/interfaces/songs.model";
import { Status } from "../../models/interfaces/status.model";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-songs_add",
  templateUrl: "songs_add.html",
})
export class SongsAddPage {
  private loading: any;
  private songs$: Observable<Songs[]>;
  private songsForm: FormGroup;
  private songs: Songs;
  private styleName: string ="";
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("SongsAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.songsForm = this.formBuilder.group({
      "so_order": [""],
      "so_text": ["", [Validators.required]],
      "so_title": ["", [Validators.required]],
    });
  }
  private ionViewWillEnter() {
    console.log("SongsAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SongsAddPage onInitPage");
  }

  private goback() {
    console.log("SongsAddPage goback");
    this.navCtrl.pop();
  }

  private addSongs() {
    console.log("SongsAddPage addSongs");
    if (this.songsForm.dirty && this.songsForm.valid) {

      this.db.dbCol({ "action": "insert", "mapObject": "songs", ...this.songsForm.value})
        .subscribe((ret3) => {
          this.navCtrl.pop();
        });
    }
  }

  private ngOnDestroy() {
    console.log("SongsAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/songs/songs_add.ts